import script from "./PlatformMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformMenu.vue?vue&type=script&setup=true&lang=js"

import "./PlatformMenu.vue?vue&type=style&index=0&id=35444834&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35444834"]])

export default __exports__